/**
 * The warning a ride manager sees when they open a trip customers already have.
 *
 * Some managers sell the same itinerary to a second customer by editing the
 * ride they already sent the first one, which silently changes the first
 * customer's trip. The right move is to duplicate it first. The warning asks
 * whether this change is for the same customer, because sometimes it is: a
 * hotel change the customer asked for belongs on the shared ride.
 *
 * "Already has it" means an active row in get_ride_connected_users, the same
 * list the ride access key page shows. A blocked customer no longer sees the
 * ride, so they do not count. The manager's own login is skipped, since they
 * often open their own link to test it.
 */

const MAX_NAMED_CUSTOMERS = 3;

// The ride's manager, on a private ride, that is not locked. The same owner
// check the header uses for its Duplicate trip button.
function canOfferSharedRideWarning({ ride, userId, isOwner, isLocked }) {
  if (!ride || !isOwner || isLocked) return false;
  if (typeof ride.ride_manager_id !== 'number') return false;
  return ride.ride_manager_id == userId;
}

// The name the connected users list shows for a user (RideConnectedUsers).
// A WhatsApp traveller's address is a synthetic wa.<phone>@whatsapp.invalid,
// so their profile name or phone stands in for it.
function connectedUserLabel(user) {
  if (user.auth_provider === 'whatsapp') {
    return user.display_name || (user.phone ? `+${user.phone}` : user.email);
  }
  return user.email;
}

function sharedRideCustomers(users, ownEmail) {
  const own = (ownEmail || '').trim().toLowerCase();
  return (users || []).filter(user =>
    user.is_active && !(own && (user.email || '').toLowerCase() === own));
}

// The first few names, and how many more there are.
function customerNamesSummary(customers, max = MAX_NAMED_CUSTOMERS) {
  return {
    names: customers.slice(0, max).map(connectedUserLabel),
    more: Math.max(0, customers.length - max),
  };
}

module.exports = {
  MAX_NAMED_CUSTOMERS,
  canOfferSharedRideWarning,
  connectedUserLabel,
  sharedRideCustomers,
  customerNamesSummary,
};
